<template>
  <div name="outcomeedit">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        <router-link to="/library/boing"> Boing Kids </router-link>
        <i class="carret fas fa-caret-right"></i> {{ title }}
      </template>

      <template v-slot:listitems> </template>
    </innertopbar>
    <div class="w-full mx-6 mb-4">
      <div class="flex flex-col sm:flex-row ml-20 mt-5 sm:ml-8">
        <div class="w-full sm:w-5/12 mr-10">
          <div
            class="block h-3/4 w-8/12"
            :title="selectedContent.title"
            :style="{ backgroundImage: 'url(' + contentImage() + ')' }"
            style="
              background-position: top left;
              background-repeat: no-repeat;
              background-size: 100% 100%;
            "
          ></div>

          <h3 class="opacity-25 my-3">© Boing Kids Ltd</h3>
          <div class="w-10/12 text-justify">
            <p>
              Discovering the joy in physical activity, by developing physical
              literacy
            </p>
            <p>
              Creating active spaces that support children use their
              imaginations to solve problems.
            </p>
          </div>
        </div>
        <div class="sm:ml-8 w-full sm:w-5/12">
          <h3 class="text-2xl font-bold">{{ selectedContent.title }}</h3>
          <h3 class="mb-3 text-orange-600">Boing Kids</h3>
          <div class="w-11/12 mb-4 h-3/4 overflow-y-auto">
            <div
              class=""
              v-for="(unit, index) in contentList"
              :key="unit.title"
              @click="showFile(unit, index)"
            >
              <div
                class="flex justify-between py-2 hover:opacity-25 cursor-pointer border-b"
              >
                <h3>{{ unit.title }}</h3>
                <i
                  v-if="shouldDisplay(unit)"
                  class="fas fa-chevron-right pt-4 pr-4 opacity-25"
                ></i>

                <i v-else class="fas fa-lock text-yellow-500 text-lg pl-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modalfile
      :url="loadFilePath()"
      :title="selectedDocument.title"
      :format="format"
      @close="showModalFile = false"
      v-if="selectedDocument != undefined && showModalFile"
      v-show="showModalFile"
    ></modalfile>

    <!------------ UPGRADE -->
    <UpgradeModal
      v-if="showUpgradeModal"
      @close="showUpgrade()"
      :area="'Resource Library'"
    ></UpgradeModal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const innertopbar = () => import("@/components/InnerTopBar.vue");
const modalfile = () => import("@/components/ModalFile.vue");
const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");

import json from "@/assets/boing_content.json";

export default {
  name: "BoingContent",
  mixins: [upgradeMixin],
  components: {
    innertopbar,
    modalfile,
    UpgradeModal,
  },
  props: {
    object: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    format() {
      return "document";
    },
    title() {
      if (this.object != undefined) {
        return this.object.title;
      }
    },
    contentList() {
      let section = this.resources.filter((row) => {
        return row.active === true && row.section === this.object.key;
      });

      return section[0] != undefined ? section[0].units : [];
    },
  },

  data() {
    return {
      selectedContent: {},
      showModalFile: false,
      selectedDocument: {},
      resources: json,
    };
  },
  created() {
    if (this.object != undefined) {
      this.selectedContent = this.object;
    } else {
      this.closeWindow();
    }
  },
  methods: {
    contentImage() {
      return require("@/assets/images/boing/" +
        this.selectedContent.image +
        "_large.png");
    },
    closeWindow() {
      this.$router.push({ path: "/library/boing" });
      window.scrollTo(0, 0);
    },
    loadFilePath(item) {
      let url = this.selectedDocument.filename;
      return "boing/" + url;
    },
    showFile(item, index) {
      if (this.shouldDisplay(item)) {
        this.selectedDocument = item;
        this.showModalFile = true;
      } else {
        this.showUpgrade();
      }
    },
    shouldDisplay(item) {
      if (item.access === 'free') {
        return true;
      } else if (this.currentUser.isOnTrial) {
        return false;
      } else {
        return this.currentAccess.boingAccess
      }
    },
  },
};
</script>
<style scoped>
</style>